module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "display-image"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#toc8",
      "id": "toc8a"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p002-002.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fb-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#toc9",
      "id": "toc9a"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("WASTED LIVES?")])])]), _vm._v(" "), _c('div', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n Dworkin’s posthumously published "), _c('i', [_vm._v("Religion Without God")]), _vm._v(", he argues that an atheist can be religious. While this claim would come as no surprise to adherents of Jainism, Theravada Buddhism, or Mimamsa Hinduism, he has in mind not these Asian religious traditions but a viewpoint common to many Western thinkers who deny theism yet recognize “nature’s intrinsic beauty” and the “inescapable responsibility” of people to “live their lives well.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft1",
      "id": "fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" Dworkin considers such an outlook religious.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Leaving aside his curious line of thought that finds sup port for religious belief in such disparate phenomena as the Grand Canyon, prowling jaguars, and the discovery by physicists of the Higgs boson, let us concentrate on his view that we should all seek to live well so as to achieve “successful” lives and avoid “wasted” ones."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft2",
      "id": "fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Does one model fit all? On this important point Dworkin wavers. He maintains that “there is, independently and objectively, a right way to live.” Yet he also recognizes “a responsibility of each person to decide for himself ethical questions about which kinds of lives are appropriate and which would be degrading for him.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft3",
      "id": "fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("What sort of life did Dworkin himself find degrading? We are not told but suspect that for such a successful academic, a “degrading life” might have been one without intellectual striving, just as a famed athlete might find degrading life as a couch potato.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("But of all possible lives, which are well-lived? To help answer this question, consider the following two fictional, though realistic, cases.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Pat received a bachelor’s degree from a prestigious college and a Ph.D. in philosophy from a leading university, then was awarded an academic position at a first-rate school, and eventually earned tenure there. Pat is the author of numerous books, articles, and reviews, is widely regarded as a leading scholar and teacher, and is admired by colleagues and students for fairness and helpfulness. Pat is happily married, has two children, enjoys playing bridge and the cello, and vacations each summer in a modest house on Cape Cod. Physically and mentally healthy, Pat is in good spirits, looking forward to years of happiness.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Lee, on the other hand, did not attend college. After high school Lee moved to a beach community in California and is devoted to sunbathing, swimming, and surfing. Lee has never married but has experienced numerous romances. Having inherited wealth from deceased parents, Lee has no financial needs but, while donating generously to worthy causes, spends money freely on magnificent homes, luxury cars, designer clothes, fine dining, golfing holidays, and extensive travel. Lee has many friends and is admired for honesty and kindness. Physically and mentally healthy, Lee is in good spirits, looking forward to years of happiness.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Both Pat and Lee live in ways that appear to suit them. Both enjoy prosperity, treat others with respect, engage in activities they find fulfilling, and report they are happy. Are both living equally well? In other words, are both pursuing equally meaningful lives? Or, alternatively, is either life wasted?")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Dworkin offers little guidance to help answer these questions. He urges that we make our lives into works of art,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft4",
      "id": "fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" but works of arttypically contain complexities and conflicts not found in the lives of Pat or Lee. The story of each might be told in the form of a play or novel, but neither individual appears to have the makings of Medea, Hamlet, or Anna Karenina.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Dworkin also remarks that “someone creates a work of art from his life if he lives and loves well in family or community with no fame or artistic achievement at all.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft5",
      "id": "fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" Here Dworkin, having urged us to live well by making our lives into works of art, unhelpfully suggests that works of art are those made by living well. This circular explanation sheds no light on how to live well, so Dworkin’s appeal to works of art does not help us choose between the lives of Pat and Lee.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Many other philosophers, however, have provided reasons for believing that Pat’s life is superior to Lee’s. These thinkers rate the pursuit of philosophical inquiry, playing the cello, or raising a family, more highly than surfing, a series of romances, or a luxurious home.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Yet not all philosophers agree with this assessment. Two who do not are Richard Taylor and Harry Frankfurt, each of whom would maintain that Pat and Lee are living equally well.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Consider first Taylor’s approach. He discusses the case of Sisyphus, who, according to Greek myth, was condemned for his misdeeds to the eternal task of rolling a huge stone to the top of a hill, only each time to have it roll down to the bottom again. Is the activity of Sisyphus meaningless? Taylor concludes that the answer depends on whether Sisyphus has a desire to roll stones up hills. Most of us don’t, but if Sisyphus does, then he has found “mission and meaning.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft6",
      "id": "fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" Therefore, according to Taylor, living well is living in accord with your desires. If your activities match your wishes, then your life is successful. Whether the activity is teaching philosophy, driving luxury cars, or rolling stones up hills makes no difference.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Frankfurt reaches a similar conclusion. He maintains that we infuse our lives with meaning by loving certain intrinsic ends and caring about the means to achieve them. Need the ends themselves be of a particular sort? Not according to Frankfurt. As he writes, “Devoting oneself to what one loves suffices to make one’s life meaningful, regardless of the inherent or objective character of the objects that are loved.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft7",
      "id": "fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" Because Pat loves discussing philosophy, playing bridge, and spending time with family, while Lee loves surfing, golfing, and engaging in romantic adventures, both, according to Frankfurt, possess the essentials of a meaningful life.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("As we noted, however, most philosophers reject this view of what makes a life significant."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch02ft8",
      "id": "fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" They maintain that certain activities are more worthy than others, so lives spent engaged in those more worthy activities are more worthy lives. But which activities have more worth and which less? And on what bases should we decide such matters?")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("We shall next consider in turn three much-discussed attempts to provide persuasive answers to these questions.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef27399","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 78
// module chunks = 0